import { useState } from "react";
import { Button } from "react-bootstrap";
import StatsLog from "../../components/coach/StatsLog";
import ExerciseLog from "../../components/coach/ExerciseLog";

const CoachScreen = () => {
    const [showStatsLog, setShowStatsLog] = useState(false);
    const [showExerciseLog, setShowExerciseLog] = useState(false);



    return (
        <>
        {showStatsLog ? <StatsLog setShowStatsLog={setShowStatsLog} /> :
        <Button onClick={() => setShowStatsLog(true)}>Log Stats</Button>
        }
        
        {showExerciseLog ? <ExerciseLog setShowExerciseLog={setShowExerciseLog} /> :
        <Button onClick={() => setShowExerciseLog(true)}>Exercise Log</Button>
        }
        </>
    )
}

export default CoachScreen